/**
 * Route for `public-trust-center-with-auditor-attestation`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PublicTrustCenterWithAuditorAttestationPage } from "../features/public-trust-center-with-auditor-attestation/PublicTrustCenterWithAuditorAttestationPage";

export const publicTrustCenterWithAuditorAttestationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/public-trust-center-with-auditor-attestation",
	component: PublicTrustCenterWithAuditorAttestationPage,
});

export default publicTrustCenterWithAuditorAttestationRoute;
